import { useState } from "react";
import { Link } from "react-router-dom";
import { articles, channels } from "@/mocks/articles";
import { chipSolid } from "@/utils/ui";

export default function ChannelBoard() {
  const [active, setActive] = useState(channels[0].id);
  const channel = channels.find((c) => c.id === active)!;
  const list = articles.filter((a) => a.category === active);

  return (
    <section className="bg-background-50 border-b border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
        <div className="flex items-end justify-between gap-4 flex-wrap">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              栏目吃瓜，各有各的门道
            </h2>
            <p className="mt-1.5 text-sm text-foreground-500">点一下栏目，看看这一路怎么吃</p>
          </div>
          <Link
            to={`/channel/${channel.id}`}
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-800 whitespace-nowrap"
          >
            进入「{channel.name}」栏目
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-6 flex flex-wrap gap-2 p-1">
          {channels.map((c) => {
            const isActive = c.id === active;
            return (
              <button
                key={c.id}
                type="button"
                onClick={() => setActive(c.id)}
                className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors border ${
                  isActive ? `${chipSolid(c.color)} border-transparent` : "border-background-300 bg-background-100 text-foreground-700 hover:bg-background-200"
                }`}
              >
                {c.name}
                <span className="text-xs opacity-80">{articles.filter((a) => a.category === c.id).length}</span>
              </button>
            );
          })}
        </div>

        <p className="mt-4 text-sm text-foreground-600 leading-6 max-w-2xl">{channel.brief}</p>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-5">
          {list.map((a) => (
            <Link
              key={a.id}
              to={`/article/${a.id}`}
              className="group flex flex-col sm:flex-row overflow-hidden rounded-xl border border-background-200 bg-background-100 hover:border-primary-300 transition-colors"
            >
              <div className="relative sm:w-2/5 h-52 sm:h-auto shrink-0 overflow-hidden">
                <img
                  src={a.image}
                  alt={a.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-col flex-1 p-4 md:p-5">
                <span className={`self-start inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${chipSolid(channel.color)}`}>
                  {channel.name}
                </span>
                <h3 className="mt-2.5 font-heading text-lg font-bold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                  {a.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-6 line-clamp-2">{a.subtitle}</p>
                <div className="mt-auto pt-3 flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-user-3-line"></i>
                    {a.author}
                    <span className="hidden sm:inline">· {a.date}</span>
                  </span>
                  <span className="flex items-center gap-1 whitespace-nowrap text-primary-600 font-medium">
                    阅读全文
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-4 flex items-center gap-2 text-xs text-foreground-500">
          <i className="ri-eye-line"></i>
          当前栏目共 {list.reduce((s, a) => s + a.views, 0)} 次热度阅读
        </div>
      </div>
    </section>
  );
}